import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddDigitalCertificateComponent } from './add-digital-certificate/add-digital-certificate.component';
import { NotificationService } from 'src/app/core/services/notification.service';
import { merge, Observable, BehaviorSubject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DataSource } from '@angular/cdk/collections';
import { MatSort, Sort } from '@angular/material/sort';
import { DigitalCertificateService } from 'src/app/core/services/digital-certificate.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/core/services/user.service';
import { ViewDigitalCertificateComponent } from './view-digital-certificate/view-digital-certificate.component';
import { EditDigitalCertificateComponent } from './edit-digital-certificate/edit-digital-certificate.component';
import { MatSelect } from '@angular/material';
import { CommonService } from 'src/app/core/services/common.service';
import { Router } from '@angular/router';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ResponsiveService } from '../../../../../core/services/responsive.service';
import {EnumSignMethod} from "../../../../../core/constants/contract";
import { DialogSyncDigitalCertificateComponent } from './dialog-sync-digital-certificate/dialog-sync-digital-certificate.component';
import { DocumentService } from 'src/app/core/services/document.service';

@Component({
  selector: 'app-digital-certificate',
  templateUrl: './digital-certificate.component.html',
  styles: [`
    @media (min-width: 200px) {
      .reponsive-table {
        min-width: 576px;
      }
    }
    @media (min-width: 768px) {
      .reponsive-table {
        min-width: 768px;
      }
    }
    @media (min-width: 922px) {
      .reponsive-table {
        min-width: 1600px;
      }
    }
    @media (min-width: 1200px) {
      .reponsive-table {
        min-width: 1800px;
      }
    }
  `]
})
export class DigitalCertificateComponent implements OnInit, AfterViewInit, OnDestroy {
  isTableLoading = false;
  // displayedColumns: string[] = [
  //   'stt',
  //   'typeCertificate',
  //   'issuedTo',
  //   'serialNumber',
  //   'taxCode',
  //   'phoneNumber',
  //   'activeDate',
  //   'expireDate',
  //   'status',
  //   'setting'
  // ];

  displayedColumns: string[] = [];

  columnDefinitions = [
    { def: "stt", showXS: true, showSM: true, showMD: true},
    { def: "typeCertificate", showXS: true, showSM: true, showMD: true },
    { def: "cloudCaProviderName", showXS: false, showSM: true, showMD: false },
    { def: "issuedTo", showXS: false, showSM: true, showMD: true },
    { def: "serialNumber", showXS: false, showSM: true, showMD: false },
    { def: "taxCode", showXS: false, showSM: true, showMD: false },
    {def: "cloudCaUsername",  showXS: false, showSM: true, showMD: false},
    { def: "phoneNumber", showXS: false, showSM: true, showMD: false },
    { def: "activeDate", showXS: false, showSM: true, showMD: false },
    // { def: "expireDate", showXS: false, showSM: true, showMD: false },
    { def: "status", showXS: true, showSM: true, showMD: true },
    { def: "isSync", showXS: false, showSM: true, showMD: false},
    { def: "hasTransSaved", showXS: false, showSM: true, showMD: false},
    { def: "action", showXS: true, showSM: true, showMD: true},
  ];

  dataSource: DigitalCertificateDataSource;
  certificateType = EnumSignMethod;

  digitalCertificate = new DigitalCertificate();
  paginate: Paginate;
  oldData = this.digitalCertificate;
  isFirstLoad = true;
  sortDirection = 'ASC';
  sortColumn = 'name';
  error = '';
  userType: any;
  checkFocus = false;
  // enterpriseId: string;
  taxCodeOrCertificateNo = ''
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('typeCertificateSelect', { static: false }) typeCertificateSelect: MatSelect;

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  isHsmPermission: boolean = false
  isNotAttestedUser: boolean = false;
  isBuyTwoService: boolean = false
  isDefaultAdmin: boolean = false
  isEasyCAPermission: boolean = false;
  isVNeIDPermission: boolean = false;
  entType = localStorage.getItem('entType')
  constructor(
    private dialog: MatDialog,
    private digitalCertificateService: DigitalCertificateService,
    private message: Message,
    private toastr: ToastrService,
    public commonService: CommonService,
    private notificationService: NotificationService,
    private router: Router,
    private responsiveService: ResponsiveService,
    private documentService: DocumentService,
  ) {
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.userType = localStorage.getItem('userType');
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
    this.isBuyTwoService = this.commonService.checkBuyTwoServiceWithoutHauntAndAdmin()
    this.isDefaultAdmin = this.commonService.checkDefaultAdmin()
  }
  ngOnInit() {
    // load data for first time
    this.loadDataForFirstTime();
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
  }

  ngAfterViewInit(page: number = 0) {
    setTimeout(_ => document.getElementById('focusSelect').focus());
    // register event for for sorting

    merge(this.sort.sortChange, page)
      .pipe(
        tap(() => this.onFilterData(this.paginate.currentPage, this.paginate.pageSize))
      )
      .subscribe();

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
    } else {
      if(this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
      }
    }
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.columnDefinitions
    //     .filter(cd => (cd.def !== 'action' && cd.def !== 'status'))
    //     .map(cd => cd.def);
    // }
  }

  /**
   * Open dialog add
   */
  openDialogAdd() {
    const dialogRef = this.dialog.open(AddDigitalCertificateComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG ? '80%' : '80%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (dialogRef.componentInstance.success) {
        this.onFilterDataAfterClose();
      }
    });
  }

  ngOnDestroy(): void {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  loadDataForFirstTime(page: number = 0, pageSize: number = 10) {

    this.dataSource = new DigitalCertificateDataSource();

    this.getSortDirection();

    this.isTableLoading = true;
    this.dataSource.setData([]);
    this.digitalCertificateService.searchDigitalCertificate(
      this.getFilterCondition(page, pageSize))
      .subscribe(response => {
        this.isTableLoading = false;
        if (this.responseHaveData(response)) {
          this.initPaginateToDisplay(response);
        }
        if (response.data && response.data.dataRow != null) {
          this.initDataToDisplay(response);
        }
      }, () => this.isTableLoading = false);

      this.digitalCertificateService.getPermissionHSM(localStorage.getItem('enterpriseId')).subscribe(res => {
        if(res && res.success){
          this.isHsmPermission = res.data.enableHsm
          this.isEasyCAPermission = this.entType == '2' ? res.data.isEnableEasyCa : false
          if(!this.isHsmPermission){
            this.digitalCertificateService.checkHsmPermission().subscribe(rs => {
              if(rs && rs.success){
                this.isHsmPermission = rs.data;
              }
            })
          }
        }
      })
      this.documentService.getApparamInfo({code: 'enable_sign_vneid'}).subscribe(res => {
        if(res.data){
          this.isVNeIDPermission = JSON.parse(res.data.value) && res.data.status;
        }
      })
  }

  responseHaveData(response: any): boolean {
    return response.data != null &&
      response.data.currentPage != null &&
      response.data.pageSize != null &&
      response.data.totalRow != null &&
      response.data.totalRow != null;
  }

  /**
   * Filter data with condition
   */
  onFilterData(page: number = 0, pageSize: number = 10) {
    // taxCodeOrCertificateNo
    this.getSortDirection();
    this.isTableLoading = true;
    this.dataSource.setData([]);
    this.digitalCertificateService.searchDigitalCertificate(
      this.getFilterCondition(page, pageSize, this.oldData.typeCertificate, this.oldData.enterpriseId))
      .subscribe(
        response => {
          this.isTableLoading = false;
          this.initPaginateToDisplay(response);
          this.initDataToDisplay(response);
        }, () => this.isTableLoading = false
      );
  }

  getSortDirection() {

    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }
  }

  initPaginateToDisplay(rs: any) {
    this.paginate = {
      currentPage: rs.data.currentPage,
      pageSize: rs.data.pageSize,
      totalRow: rs.data.totalRow,
      totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
      totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
      no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
    };
  }

  initDataToDisplay(response: any): void {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;

    response.data.dataRow.forEach(parent => {
      parent['STT'] = stt++;
    });
    this.dataSource.setData(response.data.dataRow);
  }

  getFilterCondition(
    page: number, pageSize: number,
    typeCertificateContain: any = null, enterpriseIdContain: any = null
  ): any {

    let filterCondition = {};

    filterCondition = {
      id: 0,
      typeCertificate: typeCertificateContain,
      enterpriseId: enterpriseIdContain == null || enterpriseIdContain === '' ? localStorage.getItem('enterpriseId') : enterpriseIdContain,
      page,
      pageSize,
      nameOrCode: this.taxCodeOrCertificateNo || undefined
    };

    let sortColumn = null;
    let sortDirection = null;

    sortDirection = this.sortDirection;
    sortColumn = this.sortColumn; // is searching in parent

    let column = null;

    switch (sortColumn) {

      case 'taxCode':
        column = {
          taxCode: sortDirection
        };
        break;
      case 'phoneNumber':
        column = {
          phoneNumber: sortDirection
        };
        break;
      case 'typeCertificate':
        column = {
          typeCertificate: sortDirection
        };
        break;
      case 'effectiveDate':
        column = {
          effectiveDate: sortDirection
        };
        break;
      case 'activeDate':
        column = {
          activeDate: sortDirection
        };
        break;
      // case 'expireDate':
      //   column = {
      //     expireDate: sortDirection
      //   };
      //   break;
    }

    filterCondition['sorts'] = column;

    return filterCondition;
  }

  /**
   * Count record to show
   */
  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  viewDigitalCertificateDetail(id, idDetail, typeCertificate) {
    const dialogRe = this.dialog.open(ViewDigitalCertificateComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : (typeCertificate === 3 ? '50%' : '60%'),
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '85vw',
      panelClass: 'scontract-overlay-dialog',
      data: { id, idDetail, typeCertificate }
    });

    dialogRe.afterClosed().subscribe(res =>{
      if (res && res.isReload) {
        this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
      }
    })
  }

    editDigitalCertificate(id, idDetail, typeCertificate, isSync = false) {
      this.dialog.open(EditDigitalCertificateComponent, {
        width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : (typeCertificate === 3 ? '50%' : '60%'),
        maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '85vw',
        panelClass: 'scontract-overlay-dialog',
        data: { id, idDetail, typeCertificate, isSync }
      });
    }
    getSyncCertificateById(id: string, idDetail: string) {
      this.digitalCertificateService.viewSyncDigitalCertificateDetail(id, idDetail).subscribe(rs => {
      });
    }

    syncDigitalCertificate(id, idDetail, typeCertificate) {
      const isSync = true
      this.digitalCertificateService.viewSyncDigitalCertificateDetail(id, idDetail).subscribe(rs => {
        // console.log(rs, 'rs');
        if (rs.success && rs.data) {
          const dialogRef = this.dialog.open(EditDigitalCertificateComponent, {
            width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : (typeCertificate === 3 ? '50%' : '60%'),
            maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '85vw',
            panelClass: 'scontract-overlay-dialog',
            data: { id, idDetail, typeCertificate, isSync, syncCertDetail: rs.data }
          });
          dialogRef.afterClosed().subscribe(result => {
            // console.log('result',result)
            if (result) {
              this.onFilterDataAfterClose();
            }
          });
          return;
        }
        if (rs.message) {
          this.toastr.error(rs.message )
        }
      })

    }
    sortData(sort: Sort) {

      if (!sort.active || sort.direction === '') {
        return;
      }
      this.sortColumn = sort.active;
    }

    /**
     * Change status
     */
    onChangeigitalCertificateStatus(idDetail, digitalCertificateStatus: boolean) {
      // them trang thai cho chung thu so
      var s1 = digitalCertificateStatus ? '<strong>' + this.message.getMessage('enterprise-certificate_management.cbx_certificate_status.cbx_certificate_status_active') + '</strong>'
        : '<strong>' + this.message.getMessage('enterprise-certificate_management.cbx_certificate_status.cbx_certificate_status_inactive') + '</strong>';

      var s2 = !digitalCertificateStatus ? '<strong>' + this.message.getMessage('enterprise-certificate_management.cbx_certificate_status.cbx_certificate_status_active') + '</strong>'
        : '<strong>' + this.message.getMessage('enterprise-certificate_management.cbx_certificate_status.cbx_certificate_status_inactive') + '</strong>';

      const dialogRef = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.commonService.format(this.message.getMessage('messages.confirm_change_status_digital_certificate'), s1, s2)
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.digitalCertificateService.changeStatus(idDetail).subscribe(() => {
            this.toastr.success(this.message.getMessage('messages.update_status_success'));
            this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          });
        }
      });
    }

    /**
     * Filter data when close dialog
     */
    onFilterDataAfterClose() {
      if (this.paginate.totalRow % this.paginate.pageSize === 1) {
        if (this.paginate.currentPage - 1 < 0) {
          this.paginate.currentPage = 0;
        } else {
          this.paginate.currentPage = this.paginate.currentPage - 1;
        }
      }
      this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
    }

    /**
     * Navigate to page register OTP
     */
    registerOTP() {
      this.router.navigate(['/home-enterprise/otp-register/'], {
        queryParams: {
          page: this.paginate.currentPage,
          pageSize: this.paginate.pageSize,
        }
      });
    }

    openDialogSync() {
      const dialogRef = this.dialog.open(DialogSyncDigitalCertificateComponent, {
        width: '95%',
        maxWidth: '95vw',
        panelClass: 'synchronized-overlay-dialog'
      });
      dialogRef.afterClosed().subscribe((rs) => {
        if (rs) this.onFilterData();
      });
    }
    
    autoSyncMysign(element: any){
      let label = ''
      if(element.isSync){
        label = this.message.getMessage('digital_certificate_management.change_no_sync_mysign')
      } else {
        label = this.message.getMessage('digital_certificate_management.change_yes_sync_mysign')
      }
      const dialogRef = this.dialog.open(WarningComponent, {
        width: '365px',
        data: label
      });
      dialogRef.afterClosed().subscribe((rs) => {
        if (rs) {
          this.digitalCertificateService.changeSyncMysign(!element.isSync, element.id).subscribe(res => {
            if(element.isSync){
              this.toastr.success(this.message.getMessage('digital_certificate_management.change_no_success'))
            } else {
              this.toastr.success(this.message.getMessage('digital_certificate_management.change_yes_success'))
            }
            this.onFilterData();
          })
        }
      });
    }
  }

  export class DigitalCertificate {
  id: string;
  idDetail: string;
  enterpriseId: string;
  enterpriseName: string;
  serialNumber: string;
  taxCode: string;
  activeDate: string;
  expireDate: string;
  isDeleted: boolean;
  typeCertificate: any = 'null';
  phoneNumber: string;
  filePath: string;
  issuedTo: string;

  // int ACTIVE = 0
  // int PENDING = 1
  // int EXPIRED = 2
  certificateStatus: number;
}

export class DigitalCertificateDataSource extends DataSource<DigitalCertificate> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<DigitalCertificate[]>([]);

  constructor() {
    super();
  }


  setData(data: DigitalCertificate[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<DigitalCertificate[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];
}
